import * as S from "./styles";
import DatePickerMui from "@/components/hookForms/datePicker";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton } from "@mui/material";
import { useForm } from "react-hook-form";
import CloseIcon from "@mui/icons-material/Close";
import { LoadingButton } from "@mui/lab";
import { toast } from "react-toastify";
import { format } from "date-fns";
import AutoCompleteMult from "@/components/hookForms/autoCompleteMult";
import { useEffect, useState } from "react";
import serviceConcessionaria from "@/services/serviceConcessionaria";
import IGenericResult from "@/interfaces/IGenericResult";

interface IDialogProps {
  open: boolean;
  onClose(): void;
  onConfirm?: (dataInicio: string, dataFim: string, idsConcessionarias: string) => void;
}

export interface IFiltersCicloChurn {
  CicloInicio: string;
  CicloFim: string;
  idsConcessionarias: any;
}

export default function FiltersSelect({ open, onClose, onConfirm }: IDialogProps) {
  const [concessionariaDataOptions, setConcessionariaDataOptions] = useState<IGenericResult[]>([]);
  
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<IFiltersCicloChurn>({
    defaultValues: {
      CicloInicio: "",
      CicloFim: "",
      idsConcessionarias: "",
    },
    mode: "onChange",
  });

  useEffect(() => {
    setConcessionariaData();
  }, []);

  const setConcessionariaData = async () => {
    serviceConcessionaria
      .getConcessionarias()
      .then((result) => {
        setConcessionariaDataOptions(result?.data || []);
      })
      .catch(() => {
        setConcessionariaDataOptions([]);
      });
  };

  function onSubmit(data: IFiltersCicloChurn) {

    if (!data.CicloInicio || !data.CicloFim) {
      toast.error("Por favor, preencha ambas as datas (Início e Fim)!");
      return;
    }

    const inicio = new Date(data.CicloInicio);
    const fim = new Date(data.CicloFim);
    
    if (fim <= inicio) {
      toast.error("A data de fim deve ser posterior à data de início!");
      return;
    }

    const dataInicio = format(inicio, "yyyy-MM-01");
    const dataFim = format(fim, "yyyy-MM-01");
    
    const idsConcessionarias = data.idsConcessionarias && Array.isArray(data.idsConcessionarias) 
      ? data.idsConcessionarias.join(",") 
      : "";

    if (onConfirm) {
      onConfirm(dataInicio, dataFim, idsConcessionarias);
    }

    reset();
    onClose();
  }

  return (
    <>
      <Dialog
        maxWidth="md"
        fullWidth
        onClose={() => {
          onClose();
        }}
        open={open}
      >
        <DialogTitle>
          Informe os ciclos de cobrança
          <IconButton
            aria-label="close"
            onClick={() => {
              reset();
              onClose();
            }}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <form onSubmit={handleSubmit(onSubmit)}>
          <DialogContent dividers>
            <S.Subtitles>Data</S.Subtitles>
            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <DatePickerMui
                  name="CicloInicio"
                  label="Inicio"
                  format="MM/yyyy"
                  view={["month", "year"]}
                  control={control}
                  error={errors}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <DatePickerMui
                  name="CicloFim"
                  label="Fim"
                  format="MM/yyyy"
                  view={["month", "year"]}
                  control={control}
                  error={errors}
                />
              </Grid>
            </Grid>
            <S.Subtitles>Concessionária</S.Subtitles>
            <Grid container spacing={3}>
              <Grid item xs={12} md={12}>
                <AutoCompleteMult
                  name="idsConcessionarias"
                  label="Concessionárias"
                  options={concessionariaDataOptions}
                  control={control}
                  error={errors}
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions style={{ display: "flex", justifyContent: "center", margin: "24px" }}>
            <Button
              style={{ width: "159px", height: "44px" }}
              onClick={() => {
                reset();
                onClose();
              }}
              color="warning"
              variant="contained"
            >
              Cancelar
            </Button>
            <LoadingButton
              style={{ width: "159px", height: "44px" }}
              type="submit"
              variant="contained"
            >
              Confirmar
            </LoadingButton>
          </DialogActions>
        </form>
      </Dialog>
    </>
  )
}